import{a as t}from"./ninox-components-3BPDSF2O.js";function o(n){return!!n&&typeof n=="object"&&n.constructor===Object}t(o,"isObject");export{o as a};
//# sourceMappingURL=ninox-components-SKM2R3JB.js.map